import React from 'react';

type Props = { children: React.ReactNode };
type State = { hasError: boolean; message?: string; stack?: string; componentStack?: string };

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(err: any): State {
    return { hasError: true, message: err?.message || String(err) };
  }
  componentDidCatch(error: any, info: any) {
    console.error('App error', error, info);
    this.setState({ stack: error?.stack, componentStack: info?.componentStack });
    try {
      fetch('/api/client-log', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          level: 'error',
          message: error?.message || String(error),
          stack: error?.stack || '',
          componentStack: info?.componentStack || '',
          userAgent: navigator.userAgent,
        })
      }).catch(() => {});
    } catch {}
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 16, fontFamily: 'system-ui, sans-serif' }}>
          <h2 style={{ marginBottom: 8 }}>画面の表示に失敗しました</h2>
          <p style={{ color: '#666', fontSize: 14, marginBottom: 12 }}>{this.state.message}</p>
          {this.state.componentStack && (
            <details style={{ whiteSpace: 'pre-wrap', fontSize: 12, background: '#fafafa', padding: 8, border: '1px solid #eee', marginBottom: 12 }} open>
              <summary>詳細（開発者向け）</summary>
              {this.state.componentStack}
              {this.state.stack ? ('\n' + this.state.stack) : ''}
            </details>
          )}
          <button onClick={() => { this.setState({ hasError: false }); location.reload(); }} style={{ padding: '6px 10px' }}>再読み込み</button>
        </div>
      );
    }
    return this.props.children as any;
  }
}
